import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-documents-step',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './documents-step.component.html',
})
export class DocumentsStepComponent {
  @Input({ required: true }) documents!: FormArray<FormGroup>;
  @Output() fileSelected = new EventEmitter<{ index: number; file: File }>();
  @Output() removeFile = new EventEmitter<number>();

  onFileChange(index: number, event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const file = input?.files?.[0];
    if (!file) return;
    this.fileSelected.emit({ index, file });
    if (input) input.value = '';
  }

  trackByIndex(index: number): number {
    return index;
  }
}

